<template>
  <v-card style="borderRadius:5px;">
    <v-card-title>
      Add Custom Course
    </v-card-title>
    <v-card-text class="pb-0">
      Please enter details for the course
    </v-card-text>
    <v-card-text class="pt-0">
      <v-form ref="form" v-model="valid">
        <v-text-field :rules="requireRule" label="Course Name" v-model="course_name"></v-text-field>

        <v-select
          :items='[
            { value: "Science", text: "Science" },
            { value: "nonScience", text: "Non-Science" }
          ]'
          :rules="requireRule"
          label="GPA Calculation"
          v-model="course_gpa_calculation"
        />

        <v-select
          v-if="course_gpa_calculation === 'Science'"
          :items='["Biology/Zoology", "Inorganic Chemistry", "Biochemistry", "Organic Chemistry", "Physics", "Other Science"]'
          :rules="requireRule"
          label="Subject Category"
          v-model="course_subject_category"
        />

        <v-select
          v-if="course_gpa_calculation === 'nonScience'"
          :items='["English", "Math", "Social/Behavioral Science", "Other Non-Science"]'
          :rules="requireRule"
          label="Subject Category"
          v-model="course_subject_category"
        />

        <!-- <v-select
          :items='courseCategories'
          :rules="requireRule"
          label="Course Category"
          v-model="course_category"
        /> -->

        <v-autocomplete
          :items='caspaCourseSubjects'
          :rules="requireRule"
          label="CASPA Course Subject"
          v-model="course_caspa_subject"
          clearable
        />

        <a href="https://help.liaisonedu.com/CASPA_Applicant_Help_Center/Filling_Out_Your_CASPA_Application/2._CASPA_Academic_History/4CASPA_Course_Subjects">What are CASPA course subjects?</a>

      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="$emit('cancel')" text class="red--text">Cancel</v-btn>
      <v-btn @click="handleSaveCourse" :disabled="!valid" color="green" class="white--text">Add Course</v-btn>
      
    </v-card-actions>
  </v-card>
</template>
<script>
import caspaSubjects from '@/lib/caspaSubjects'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      caspaSubjects,
      valid: false,
      courseCategories: [],
      courseCaspaSubject: null,
      requireRule: [
        v => !!v || 'Required'
      ],
      course_name: null,
      course_caspa_subject: null,
      course_subject_category: null,
      course_gpa_calculation: null,
      course_category: null,
    }
  },
  created () {
    this.$firebase.database().ref('course_categories').once('value', (docs) => {
      const docsRef = docs.val()
      const options = []
      for (const key in docsRef) {
        if (docsRef.hasOwnProperty(key)) {
          const element = docsRef[key];
          options.push({
            value: key,
            text: element.category_name
          })
        }
      }
      this.courseCategories = options
    })
    // course_categories
  },
  methods: {
    ...mapActions(['saveCustomCourse']),
    async handleSaveCourse () {
      if (!this.$refs.form.validate()) return null
      const {
        course_name,
        course_caspa_subject,
        course_subject_category,
        course_gpa_calculation,
        course_category
      } = this
      const courseId = await this.saveCustomCourse({
        course_name,
        course_caspa_subject,
        course_subject_category,
        course_gpa_calculation,
        course_category
      })
      this.$emit('cancel', courseId)
    }
  },
  computed: {
    caspaCourseSubjects () {
       return caspaSubjects.sort((courseA, courseB) => {
        if(courseA < courseB) {
         return -1;
        }
        if(courseA > courseB) {
          return 1;
        }
     })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Courses/AddCustomCourse.vue